// Subtle background doodles (clouds, arrows, code symbols, dots, sparkles)
// reinforcing the Kwarizmix mascot illustration style. Purely decorative.
export function SectionDecor({ className = "" }) {
  return (
    <div className={`pointer-events-none absolute inset-0 overflow-hidden select-none ${className}`} aria-hidden="true">
      {/* cloud */}
      <svg className="absolute top-10 left-[6%] w-16 h-10 text-sky-200/70" viewBox="0 0 64 40" fill="currentColor">
        <path d="M20 34a12 12 0 0 1 1-24 14 14 0 0 1 26 4 9 9 0 0 1-3 20z" />
      </svg>
      <svg className="absolute bottom-8 right-[10%] w-20 h-12 text-sky-200/60" viewBox="0 0 64 40" fill="currentColor">
        <path d="M20 34a12 12 0 0 1 1-24 14 14 0 0 1 26 4 9 9 0 0 1-3 20z" />
      </svg>

      {/* dashed arrow */}
      <svg className="absolute top-24 right-[16%] w-24 h-16 text-sky-300/70" viewBox="0 0 100 60" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeDasharray="2 8">
        <path d="M4 50 C 30 10, 60 10, 92 34" />
      </svg>

      {/* dotted grid */}
      <svg className="absolute bottom-16 left-[14%] w-16 h-16 text-violet-300/60" viewBox="0 0 60 60" fill="currentColor">
        {[6, 22, 38, 54].map((y) => [6, 22, 38, 54].map((x) => <circle key={`${x}-${y}`} cx={x} cy={y} r="2.4" />))}
      </svg>

      {/* code symbols */}
      <span className="absolute top-1/3 left-[3%] font-mono font-black text-2xl text-sky-300/70">&lt;/&gt;</span>
      <span className="absolute top-16 right-[6%] font-mono font-black text-2xl text-amber-300/80">{"{ }"}</span>

      {/* plus signs */}
      <span className="absolute top-1/2 right-[4%] text-rose-300/70 text-2xl font-black">+</span>
      <span className="absolute bottom-1/3 left-[42%] text-amber-300/70 text-xl font-black">+</span>
      <span className="absolute top-8 left-[38%] text-teal-300/70 text-lg font-black">+</span>

      {/* sparkles */}
      <svg className="absolute top-1/2 left-[24%] w-6 h-6 text-amber-300/80" viewBox="0 0 24 24" fill="currentColor">
        <path d="M12 0l2.5 8.5L23 11l-8.5 2.5L12 22l-2.5-8.5L1 11l8.5-2.5z" />
      </svg>
      <svg className="absolute bottom-10 right-[30%] w-4 h-4 text-teal-300/80" viewBox="0 0 24 24" fill="currentColor">
        <path d="M12 0l2.5 8.5L23 11l-8.5 2.5L12 22l-2.5-8.5L1 11l8.5-2.5z" />
      </svg>
    </div>
  );
}
